import { useId } from 'react'
import type { PresenceStatus } from '@/types/api'

const FILL: Record<PresenceStatus, string> = {
  online: 'var(--status-online)',
  idle: 'var(--status-idle)',
  dnd: 'var(--status-dnd)',
  offline: 'var(--status-offline)',
  invisible: 'var(--status-offline)',
}

interface Props {
  status: PresenceStatus
  size?: number
  className?: string | undefined
  /** Подпись для чтения с экрана; без неё значок декоративный (подпись есть рядом текстом). */
  label?: string | undefined
}

/**
 * Значок статуса отличается не только цветом, но и формой — для тех, кто плохо различает
 * цвета: в сети — полный зелёный круг, неактивен — жёлтый полумесяц, не беспокоить — красный
 * круг с поперечной чертой, не в сети и невидимый — серое кольцо. Вырезы прозрачные (маска),
 * поэтому значок одинаково читается на любом фоне — и на подсветке пункта меню.
 */
export function StatusIcon({ status, size = 10, className, label }: Props) {
  // useId даёт двоеточия и кавычки-ёлочки — в url(#…) маски им не место
  const mask = `status${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`
  const fill = FILL[status] ?? FILL.offline
  const cut =
    status === 'idle' ? <circle cx="2.5" cy="2.5" r="3.75" fill="#000" />
    : status === 'dnd' ? <rect x="2.25" y="4" width="5.5" height="2" rx="1" fill="#000" />
    : status === 'online' ? null
    : <circle cx="5" cy="5" r="2.5" fill="#000" />
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 10 10"
      data-status={status}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      {cut ? (
        <>
          <mask id={mask}>
            <circle cx="5" cy="5" r="5" fill="#fff" />
            {cut}
          </mask>
          <circle cx="5" cy="5" r="5" fill={fill} mask={`url(#${mask})`} />
        </>
      ) : (
        <circle cx="5" cy="5" r="5" fill={fill} />
      )}
    </svg>
  )
}
